import { useMutation } from "urql"

import type { OrderMutationUpdateArgs, UpdatePurchaseOrderMutation } from "@/graphql/codegen/graphql"
import { UpdatePurchaseOrderDocument } from "@/graphql/codegen/graphql"

interface UseUpdatePOReturn {
  fetching: boolean
  updatePO: (data: OrderMutationUpdateArgs) => Promise<void>
}

export const useUpdatePO = ({ callback }: { callback?: (order: any) => Promise<void> | void }): UseUpdatePOReturn => {
  const [{ fetching }, updatePOMutation] = useMutation<UpdatePurchaseOrderMutation, OrderMutationUpdateArgs>(
    UpdatePurchaseOrderDocument
  )

  const updatePO = async (data: OrderMutationUpdateArgs) => {
    const result = await updatePOMutation(data)

    if (result.error) {
      throw new Error(result.error.message)
    }

    const updateResult = result.data?.order.update

    if (updateResult?.__typename === "OrderUpdateFailure") {
      throw new Error(updateResult.error.message)
    }
    if (updateResult?.__typename === "OrderUpdateSuccess") {
      callback?.(updateResult)
    }
  }

  return { updatePO, fetching }
}
